import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGossipGrid from './components/HotGossipGrid';
import LatestTracking from './components/LatestTracking';
import TrendingSection from './components/TrendingSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotGossipGrid />
        <LatestTracking />
        <TrendingSection />
      </main>
      <Footer />
    </>
  );
}